<script>
    export default {
        name: "Cookie Bar",
        data: () => ({
            showCookieBar: false,
            hideAnimation: false,
        }),
        methods: {
            acceptCookies() {
                localStorage.setItem('cookiesAccepted', 'true');
                this.$refs.cookie.classList.add('hide-animation')
                setTimeout(() => this.showCookieBar = false, 1000)
            },
        },
        mounted() {
            if (!localStorage.getItem('cookiesAccepted')) {
                this.showCookieBar = true;
                setTimeout(() => {
                    this.acceptCookies()
                }, 5000)
            }
        },
    }
</script>
<template>
    <div v-if="showCookieBar" ref="cookie" :class="['cookie-bar', hideAnimation ? 'hide-animation': '']">
        <div class="animated-border">
            <svg width="30" height="31" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 21C8.61667 21 7.31667 20.7373 6.1 20.212C4.88333 19.6867 3.825 18.9743 2.925 18.075C2.025 17.1757 1.31267 16.1173 0.788 14.9C0.263333 13.6827 0.000666667 12.3827 0 11C0 9.65 0.279333 8.33766 0.838 7.063C1.39667 5.78833 2.17167 4.66733 3.163 3.7C4.15433 2.73266 5.33333 1.99933 6.7 1.5C8.06667 1.00066 9.56667 0.850664 11.2 1.05C11.45 1.08333 11.6417 1.18766 11.775 1.363C11.9083 1.53833 11.9833 1.77566 12 2.075C12.0333 3.14166 12.4293 4.05433 13.188 4.813C13.9467 5.57166 14.8507 5.96733 15.9 6C16.25 6.01666 16.5167 6.11666 16.7 6.3C16.8833 6.48333 16.9833 6.76666 17 7.15C17.0333 7.85 17.246 8.425 17.638 8.875C18.03 9.325 18.5757 9.66666 19.275 9.9C19.5083 9.98333 19.6877 10.1043 19.813 10.263C19.9383 10.4217 20.0007 10.6173 20 10.85C20.0333 12.2333 19.7917 13.5417 19.275 14.775C18.7583 16.0083 18.05 17.0877 17.15 18.013C16.25 18.9383 15.1833 19.6673 13.95 20.2C12.7167 20.7327 11.4 20.9993 10 21ZM8.5 9C8.91667 9 9.271 8.85433 9.563 8.563C9.855 8.27166 10.0007 7.91733 10 7.5C9.99933 7.08266 9.85367 6.72866 9.563 6.438C9.27233 6.14733 8.918 6.00133 8.5 6C8.082 5.99866 7.728 6.14466 7.438 6.438C7.148 6.73133 7.002 7.08533 7 7.5C6.998 7.91466 7.144 8.269 7.438 8.563C7.732 8.857 8.086 9.00266 8.5 9ZM6.5 14C6.91667 14 7.271 13.8543 7.563 13.563C7.855 13.2717 8.00067 12.9173 8 12.5C7.99933 12.0827 7.85367 11.7287 7.563 11.438C7.27233 11.1473 6.918 11.0013 6.5 11C6.082 10.9987 5.728 11.1447 5.438 11.438C5.148 11.7313 5.002 12.0853 5 12.5C4.998 12.9147 5.144 13.269 5.438 13.563C5.732 13.857 6.086 14.0027 6.5 14ZM13 15C13.2833 15 13.521 14.904 13.713 14.712C13.905 14.52 14.0007 14.2827 14 14C13.9993 13.7173 13.9033 13.48 13.712 13.288C13.5207 13.096 13.2833 13 13 13C12.7167 13 12.4793 13.096 12.288 13.288C12.0967 13.48 12.0007 13.7173 12 14C11.9993 14.2827 12.0953 14.5203 12.288 14.713C12.4807 14.9057 12.718 15.0013 13 15Z" fill="black"/>
            </svg>
            <span>
                Мы используем файлы cookie для хранения ваших данных. Продолжая пользоваться сайтом, вы соглашаетесь с <a href="#">Политикой конфиденциальности</a>.
            </span>
        </div>
    </div>
</template>

<style lang="scss">
@use '~@/assets/styles/vars' as *;

.cookie-bar {
        background: rgba(255, 255, 255, 0.7);
        box-shadow: $shadow;
        box-sizing: border-box;

        backdrop-filter: blur(10px);

        position: fixed;
        bottom: 45px;
        left: 50%;
        transform: translateX(-50%);
    }

    .cookie-bar.hide-animation {
        animation: hideCookie 1s ease-in-out;
    }

    .cookie-bar span {
        color: black;
        font-size: 0.85rem;
    }

    @keyframes hideCookie {
        0% {
            bottom: 45px
        }

        100% {
            bottom: -60px
        }
    }

    .cookie-bar a {
        text-decoration: underline;
    }


    @property --bg-angle {
        inherits: false;
        initial-value: 0deg;
        syntax: "<angle>";
    }

    :root {
        --bg-angle: 0deg;
    }

    .animated-border {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: center;
        box-sizing: border-box;
        padding: 15px;
        cursor: pointer;

        border: 2px solid transparent;
        background:
            linear-gradient(
                    to bottom,
                    #fff, #fff
            )
            padding-box,
            conic-gradient(
                    from var(--bg-angle),
                    $white 0%,
                    $white 40%,
                    $purple 50%,
                    $white 60%,
                    $white 100%
            )
            border-box;
        animation: spin 1s infinite linear;
    }

    @keyframes spin {
        0% {
            --bg-angle: 0deg;
        }
        1.9% {
            --bg-angle: 35deg;
        }
        47.7% {
            --bg-angle: 145deg;
        }
        51.5% {
            --bg-angle: 215deg;
        }
        97.1% {
            --bg-angle: 325deg;
        }
        100% {
            --bg-angle: 360deg;
        }


        // 0-65 - быстро
        // 65-115 - медленнее
        // 115-245 - быстрее
        // 245-295 - медленнее
        // 295-360 - быстрее

    }

    @media screen and (max-width: 750px) {
        .cookie-bar {
            width: 90%;
            z-index: 21;
        }

        .cookie-bar span {
            font-size: 12px;
        }
    }
</style>